module.exports = __webpack_public_path__ + "img/add-dashed-circle.8c7553fa.gif";